window.Order = {
	treatDeliveryPost: function (data) {
		var $formOrder = $("#form-make-order");
		$formOrder.find("[name=user_address_post_pvz]").val(JSON.stringify(data));
		$formOrder.find('#tab-delivery .btn-next-step').trigger('click');
	},
	treatDeliveryPostCourier: function(data) {
		var $formOrder = $("#form-make-order");
		$formOrder.find("[name=user_address_post_courier]").val(JSON.stringify(data));
		$formOrder.find('#tab-delivery .btn-next-step').trigger('click');
		$formOrder.find('[name=user_comment]').val(data.comment);
	},
	validateDelivery: function () {
		var $formOrder = $("#form-make-order");
		var delivery = $formOrder.find('[name=type_delivery]:checked').val();

		if (delivery == 3) {
			var postTypePvzValue = $formOrder.find('[name=user_address_post_pvz]').val();

			if (!postTypePvzValue) {
				alert('Пожалуйста, выберите пункт, в котором вы хотите забрать заказ!');
				return false;
			}
		} else if (delivery == 4) {
			var postTypeCourierValue = $formOrder.find('[name=user_address_post_courier]').val();

			if (!postTypeCourierValue) {
				alert('Пожалуйста, укажите адрес доставки и нажмите кнопку "Подтвердить заказ"!');
				return false;
			}
		}

		return true;
	},
};

window.Order.Tabber = {
	validateAndOpen: function ($tabNext) {
		var valid = true;

		var $previousTabs = $tabNext.prevAll('.tab-pane').reverse();

		Order.Tabber.saveTabFields($previousTabs.last());

		$previousTabs.each(function (i, e) {
			if (!Order.Tabber.validateTab($(e))) {
				$(e).closest('form').find('.nav-tabs a[data-toggle="tab"][href="#' + $(e).attr('id') + '"]').tab('show');

				// focus
				$(e).find('.is-invalid').eq(0).focus();

				valid = false;

				return false;
			}
		});

		if (valid) {
			var callback = $tabNext.data('callback');
			if (callback) {
				(new Function(callback))();
			}

			Order.Tabber.restoreTabFields($tabNext);
			$tabNext.closest('form').find('.nav-tabs a[data-toggle="tab"][href="#' + $tabNext.attr('id') + '"]').tab('show');
		}
	},
	validateTab: function ($tab) {
		var valid = true;

		$tab.find('input[type=text][required],input[type=number][required]').each(function () {
			if (!$(this).val()) {
				$(this).addClass('is-invalid');
				valid = false;
			} else {
				$(this).removeClass('is-invalid');
			}
		});

		var $radios = $tab.find('input[type=radio][required]');
		var radioNames = $radios.map(function (i, e) {
			return $(this).attr('name');
		}).toArray();

		for (var i in radioNames) {
			var $elements = $tab.find('input[type=radio][required][name="' + radioNames[i] + '"]');
			var checked = $elements.filter(function (i, e) {
				return $(e).is(':checked');
			}).length > 0;

			if (!checked) {
				$elements.addClass('is-invalid');
				valid = false;
			} else {
				$elements.removeClass('is-invalid');
			}
		}

		var $checkers = $tab.find('input[type=checkbox][required]');
		var checkersNames = $checkers.map(function (i, e) {
			return $(this).attr('name');
		}).toArray();

		for (var i in checkersNames) {
			var $elementsCheckers = $tab.find('input[type=checkbox][required][name="' + checkersNames[i] + '"]');
			var checked = $elementsCheckers.filter(function (i, e) {
				return $(e).is(':checked');
			}).length > 0;

			if (!checked) {
				$elementsCheckers.addClass('is-invalid');
				valid = false;
			} else {
				$elementsCheckers.removeClass('is-invalid');
			}
		}

		return valid;
	},

	saveTabFields: function ($tab) {
		$tab.find('.saveable').each(function () {
			var val = $(this).val();
			if (!val) return;
			localStorage.setItem('order_'+$(this).attr('name'), val);
		});
	},
	restoreTabFields: function ($tab) {
		$tab.find('.saveable').each(function () {
			if ($(this).val()) return;
			var savedVal = localStorage.getItem('order_'+$(this).attr('name'));
			if (savedVal) {
				$(this).val(savedVal);
			}
		});
	},

	loadResultInfo: function () {
		var $tab = $("#form-make-order #tab-additional");

		var params = $("#form-make-order").serializeArray();
		params.push({
			name: 'step',
			value: 5,
		});

		$.get('/cart/step_total', params, function (data) {
			var views = ['dp_info', 'products'];

			for (var v in views) {
				var viewName = views[v];

				if (data.view[viewName]) {
					$tab.find('[data-view="' + viewName + '"]').html(data.view[viewName]);
				}
			}
		});
	},
};

$(document).ready(function () {
	var $formOrder = $("#form-make-order");

	$(document).on('click', '#form-make-order [data-to-step]', function () {
		var st = $(this).data('to-step');
		$formOrder.find('.nav [data-step="' + st + '"]').trigger('click');
		$([document.documentElement, document.body]).animate({
			scrollTop: $formOrder.offset().top + 100
		}, 100);
		return false;
	});

	$formOrder.find('.nav a[data-step]').click(function () {
		var $tabNext = $formOrder.find($(this).attr('href'));

		var currentIndex = $formOrder.find('.nav a[data-step].active').data('step');
		var nextIndex = $(this).data('step');

		if (nextIndex > currentIndex) {
			var validator = $(this).data('validator');
			if (validator) {
				var validate = eval(validator);
				if (validate === false) return false;
			}

			Order.Tabber.validateAndOpen($tabNext);
			return false;
		}
	});

	$formOrder.find('[name=type_delivery]').change(function () {
		let val = parseInt($(this).val());

		var $allDeliveryInfo = $formOrder.find('.delivery-info');
		$allDeliveryInfo.find('.make-required').removeAttr('required');
		$allDeliveryInfo.hide();

		var $currentDeliveryInfo = $formOrder.find('.delivery-info[data-type="' + val + '"]');
		$currentDeliveryInfo.find('.make-required').attr('required', 'required');
		$currentDeliveryInfo.show();

		var payments = $(this).data('payments').toString().split(',');
		$formOrder.find('[name=type_payment]').attr('disabled', 'disabled').prop('checked', false);
		for(var p in payments) {
			$formOrder.find('[name=type_payment][value="'+payments[p]+'"]').removeAttr('disabled');
		}
	});

	$(document).on("keydown", "#form-make-order", function (event) {
		return event.key != "Enter";
	});
});